<template>
    <div class="modal" :class="{ 'is-active': isActive }">
        <div class="modal-background" @click="closeModal"></div>
        <div class="modal-content">
            <div class="box">
                <article class="media">
                    <div class="media-content">
                        <div class="content">
                            <h3 class="title has-text-danger has-text-centered">RECEIVABLES {{ username ? ' - '+username : '' }}</h3>
                            <div class="theme-table-container table-container center-column w-100">
                                <table class="theme-table table is-responsive-table is-fullwidth is-scrollable is-striped">
                                    <thead>
                                        <tr>
                                            <th>Invoice #</th>
                                            <th>Issue Date</th>
                                            <th>Due Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="invoice in receivables">
                                            <td>{{ invoice.id }}</td>
                                            <td>{{ invoice.issued_date }}</td>
                                            <td>{{ getCurrency }}{{ (invoice.balance_due - invoice.paid_amount) | formatNumber }}</td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                    <tr>
                                        <th colspan="2" align="right">Total</th>
                                        <th>{{ getCurrency }}{{ totalReceivables | formatNumber }}</th>
                                    </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                </article>
            </div>
        </div>
        <button class="modal-close is-large" aria-label="close" @click="closeModal"></button>
    </div>
</template>

<script>
    export default {
        props: ['username'],
        computed: {
            isActive() {
                return this.$store.getters.getReceivablesModalStatus
            },
            receivables(){
                return this.$store.getters.getReceivables
            },
            totalReceivables(){
                let total_receivables = 0;
                this.receivables.forEach((invoice) => {
                    total_receivables += Number(invoice.balance_due) - Number(invoice.paid_amount)
                })
                return total_receivables;
            },
            getCurrency(){
                return this.$store.getters.getCurrentUser.info.price_plan.deposit_rate == 1 ? '¥' : '$'
            }
        },
        methods: {
            closeModal () {
                this.$store.commit('setReceivablesModalStatus', false)
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Banking/ReceivalbesModal.vue